/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from 'react';
import { Input, Icon } from 'antd';
import { debounce } from 'lodash';

class Inputlayer extends Component {



    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            error: [],
            value: null,
            feildData: {},
        };
        this.handleKeyPress = this.handleKeyPress.bind(this);
        // this.inputnumberChange = this.inputnumberChange.bind(this);
        this.inputBlur = this.inputBlur.bind(this);
    }
    componentDidMount() {
        let { feildData } = this.props;
        this.setState({ 'feildData': feildData, 'value': feildData.value })
    }
    componentDidUpdate(prevProps, prevState) {
        let prev_value = prevState.value
        let { feildData } = this.props;
        if (feildData.value !== prev_value) {
            this.setState({ 'feildData': feildData, 'value': feildData.value })
        }
    }
    componentWillUnmount() {
        this.setState({
            date: new Date(),
            error: [],
            value: null,
            feildData: {}
        })
    }

    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         date: new Date(),
    //         feildData:{}
    //     };
    // }
    // componentDidMount() {
    //     // console.log(this.props);
    //     let{feildData} = this.props;
    //     this.setState((state)=>({'feildData':feildData}))

    // }

    // componentDidUpdate(prevProps, pervState){
    // //    console.log(this.props);
    //     if(this.props.feildData.value && prevProps.feildData.value != this.props.feildData.value && this.props.feildData.value !== 'NAN'){
    //         // let{feildData} = this.props;
    //         this.setState((state)=>({'feildData':this.props.feildData}))
    //     }
    // }

    processChange = (event) => {
        event.persist();
        if (!this.debouncedFn) {
            this.debouncedFn = debounce(() => {
                this.handleKeyPress(event);
            }, 300);
        }
        this.debouncedFn();
    }
    handleKeyPress(event) {
        let { feildData } = this.props;
        if (feildData.input_type === 'number') {
            let event_value = event.target.value;
            if (event_value >= 0) {
                this.setState({ 'value': event.target.value }, () => {
                    this.inputBlur();
                });
            } else {
                this.inputRef.value = null;
                this.setState({ 'value': 0 }, () => {
                    this.inputBlur();
                });
            }
        } else {
            if(feildData['name']==='name' || feildData['name']==='user_id'){
                let values=event.target.value.replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, '');
                this.setState({ 'value': event.target.value }, () => {
                    this.inputBlur();
                });
            }else{
                this.setState({ 'value': event.target.value }, () => {
                    this.inputBlur();
                });
            }
           
        }

    }
    
    


    inputBlur() {
        console.log('dearch');
        let { value, error } = this.state;
        let { feildData } = this.props;
            feildData['value'] = value;
            feildData['error'] = error;
            this.props.onInputChanges({ enter: false, name: feildData['name'], 'text': value, 'value': value })  
    }


    onChange($event) {
        // this.props.onInputChanges({ enter: false, name: $event.target.name, text: $event.target.value, value: $event.target.value });
    }
    formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }
    render() {
        let { feildData } = this.props;
        let { value } = this.state;
        //  console.log(feildData,feildData.name,feildData.value);
        if (feildData.name === 'approched_time') {
            feildData.value = this.formatAMPM(new Date);
        }
        if (feildData.name === 'umr_number') {
            localStorage.setItem('UMRVALUE', this.state.feildData.value)
        }
        return (
            <div className="form-group mb-0">
                {(Object.keys(feildData).length !== 0) &&
                    <React.Fragment>

                        {feildData.disable && <p className="mb-0 disable ant-input ant-input-disabled">{feildData.value ? feildData.value : null}</p>}

                        {feildData.disable === false &&
                            <React.Fragment>

                                <input 
                                autoComplete="off"
                                 ref={(inputRef =>(this.inputRef = inputRef))}
                                 
                                 type={feildData.input_type} className="ant-input" 
                                 id={feildData.name} 
                                 placeholder={feildData.placeholder}
                                  disabled={feildData.disable ? feildData.disable : false} 
                                 defaultValue={value}
                                 onKeyUp={this.processChange.bind(this)}
                                //  onChange={this.handleKeyPress}
                                //   onBlur={this.handleKeyPress}
                                  />



                                {/* <Input
                                    value={feildData.value}
                                    type={feildData.input_type}
                                    name={feildData.name}
                                    onChange={(e) => this.handleKeyPress(e)}
                                    onKeyPress={(e) => this.handleKeyPress(e)}
                                    onBlur={this.inputBlur.bind(this)}
                                    disabled={feildData.disable ? feildData.disable : false}
                                    placeholder={feildData.placeholder}
                                    min={0}
                                // suffix={<Icon type = {feildData.icon} style = {{ color: 'rgba(0,0,0,.25)' }}/>}
                                /> */}
                                {feildData.errors.map((error, eKey) => {
                                    return (<small key={eKey} className="form-text text-danger">{error.message}</small>);
                                })}

                            </React.Fragment>}

                    </React.Fragment>}
            </div>
        );
    }
}

export default Inputlayer;
